// extracted by mini-css-extract-plugin
export default {"nav":"nav__tYYP6","selection":"selection__-3wz5","btn-nav":"btn-nav__FC01U","btnNav":"btn-nav__FC01U","active":"active__l3fbS"};